import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { setSnackbar } from "@Redux/snackBarSlice";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import LogoTitle from "@Components/LogoTitle/LogoTitle";
import FormPageTemplate from "@Pages/FormPageTemplate/FormPageTemplate";
import loginLeftPage from "@Assets/BG2.jpg";
import themeCreator from "@Themes/themeCreator";
import { USER_FORGOT_PASS } from "@API/APIRoutes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EmailVerifyScreenStyle from "./EmailVerifyScreenStyle";
import { home as HOME, verificationCode } from "@Routes/DefaultRoutes";
import { Grid, Typography, TextField, Button, Box } from "@mui/material";
import axios from "@API/axios";
import useGetItem from "../../Hooks/useGetItem";

export default function EmailVerifyScreen() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const customTheme = themeCreator();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getItem = useGetItem();

  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState();

  const handleNavigateToVerificationCode = (email) => {
    navigate(verificationCode.replace(":email", encodeURIComponent(email)));
  };

  const onVerifySubmit = () => {
    setLoading(true);

    axios
      .get(USER_FORGOT_PASS, { params: { email: userEmail } })
      .then((response) => {
        dispatch(
          setSnackbar({
            open: true,
            message: "OTP sent to your email.",
            error: false,
          })
        );
        handleNavigateToVerificationCode(userEmail);
      })
      .catch((err) => {
        setLoading(false);
        dispatch(
          setSnackbar({
            open: true,
            message:
              typeof err.response?.data === "object"
                ? err.response?.data.details
                : err.response?.data,
            error: true,
          })
        );
      });
  };

  const handleOnChange = (email) => {
    setUserEmail(email);
    setValue("email", email, { shouldValidate: true });
  };

  const rightGridContent = (
    <>
      <form onSubmit={handleSubmit(onVerifySubmit)} className="formWrapper">
        <Grid
          container
          spacing={2}
          className="inputContainer"
          justifyContent="flex-end"
        >
          <Grid item xs={12} justifyContent="flex-start">
            <LogoTitle isDisabled />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 2, mt: 2 }} align="left">
              Recover Your Account
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              placeholder="Enter An Email to Recover"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid email format",
                },
              })}
              value={userEmail}
              onChange={(e) => handleOnChange(e.target.value)}
              // inputRef={inputEmail}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          </Grid>
          <Box className="submissionBox">
            <Button
              type="submit"
              variant="contained"
              className="submissionButton"
              size="large"
              disabled={loading}
            >
              {!loading ? (
                "Verify"
              ) : (
                <LoadingComponent size="2em" thickness={5} color="white" />
              )}
            </Button>
          </Box>
        </Grid>
      </form>
    </>
  );

  return (
    <EmailVerifyScreenStyle>
      <FormPageTemplate
        rightGridForm={rightGridContent}
        leftGridTitle="Email Verification Page"
        textColor={customTheme.palette.white.main}
        leftGridBG={loginLeftPage}
        backUrl={"/"} // URL to navigate back to
      />
    </EmailVerifyScreenStyle>
  );
}
